import { connect } from 'react-redux';
import {
  getSliceContent,
  getWaitlistSubmissionError,
  isWaitlistSubmissionBusy,
  isWaitlistSubmissionFormVisible,
  isWaitlistSubmissionSubmitted,
} from '../../selectors';
import { subscribeToWaitlistClicked, toogleWaitlistFormVisibility } from '../../actions';
import get from '../../helpers/get';

const mapStateToProps = (state, { sliceId }) => (
  {
    title: get(getSliceContent(state, sliceId), ['signup_title', 'text']),
    copy: get(getSliceContent(state, sliceId), ['signup_copy']),
    emailPlaceholder: get(getSliceContent(state, sliceId), ['signup_email_placeholder']),
    successMessage: get(getSliceContent(state, sliceId), ['signup_success_message']),
    ctaText: get(getSliceContent(state, sliceId), ['cta_text']),
    ctaMobileText: get(getSliceContent(state, sliceId), ['cta_mobile_text']),
    source: getSliceContent(state, sliceId).signup_source,
    list: getSliceContent(state, sliceId).signup_list_id,
    busy: isWaitlistSubmissionBusy(state, sliceId),
    submitted: isWaitlistSubmissionSubmitted(state, sliceId),
    error: getWaitlistSubmissionError(state, sliceId),
    formVisible: isWaitlistSubmissionFormVisible(state, sliceId),
  }
);

const mapDispatchToProps = dispatch => ({
  signUpClick: (sliceId, data) => {
    dispatch(subscribeToWaitlistClicked(sliceId, data));
  },
  toggleVisibility: sliceId => {
    dispatch(toogleWaitlistFormVisibility(sliceId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
